<template>
  <div class="text-center">
    请稍候
  </div>
</template>

<script>
  import { setToken } from '@/libs/util'
  export default {
    name: 'set-token',
    data () {
      return {
        token: this.$route.query.token,
        url: this.$route.query.url
      }
    },
    mounted() {
      console.log('设置token：['+ this.token +']，['+ this.url +']')
      if (this.token != null && this.token.length > 0) {
        setToken(this.token)
      }
      if (this.url) {
        window.location.href = this.url;
      } else {
        window.location.href = '/';
      }
    }
  }
</script>

<style lang="less" scoped>

</style>
